import IcAi from "@/assets/icons/ic-AI.svg";

interface AgentRecommendationBoxProps {
  agentCount: number;
}

export function AgentRecommendationBox({ agentCount }: AgentRecommendationBoxProps) {
  const message =
    agentCount >= 3
      ? "귀하의 요구사항을 이행하기 위해, 시스템 내부에서 상호작용하거나 외부 파트너로서 협업할 수 있는 3가지 핵심 AI 에이전트를 제안합니다."
      : `귀하의 요구사항을 이행하기 위해, 시스템 내부에서 상호작용하거나 외부 파트너로서 협업할 수 있는 ${agentCount}개의 핵심 AI 에이전트를 제안합니다. 추가 에이전트를 원하시려면 요청 양식을 제출해 주세요.`;

  return (
    <div className="shadow-custom rounded-[4px]">
      <div className="flex items-center gap-3 px-2 py-2 bg-[#EBEBEB] rounded-t-[4px]">
        <img src={IcAi} alt="AI Icon" />
        <span className="text-xl font-normal text-[#000000]">AI Recommendation</span>
      </div>
      <div className="flex flex-col gap-2 py-3 px-4 bg-white rounded-b-[4px]  leading-5">
        <p className="text-sm text-[#000000]">
          귀하께 분석된 기업 규모와 산업군 추적을 통해 귀하께 도움이 되는 AI 에이전트로 전환됩니다.
          전환됨에 따라 귀하께서 Design-to-code 환경에 빠르게 접근 및 활동할 수 있는 사용 가능한
          콘텐츠로 재생산됩니다. AI Agentic AI Agents에서 반환된 콘텐츠인 모듈/명령(Agentic
          Recommendation Engine Agent)의 그것으로부터 다음처럼 처리하여 드립니다.
        </p>
        {agentCount > 0 && <p className="text-sm text-[#000000]">{message}</p>}
      </div>
    </div>
  );
}
